/**
 * big-footer.js
 */

// Import
import "./big-footer.scss";
import $ from 'jquery';

$(document).ready(function() {

});



